(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-link-mosaic"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = root => {
      if (root.dataset.collectionLinkMosaicReady === 'true') return;

      const track = root.querySelector('[data-collection-link-mosaic-track]');
      const prev = root.querySelector('[data-collection-link-mosaic-prev]');
      const next = root.querySelector('[data-collection-link-mosaic-next]');

      if (!track) return;

      root.dataset.collectionLinkMosaicReady = 'true';

      const updateButtons = () => {
        const maxScroll = track.scrollWidth - track.clientWidth - 1;
        if (prev) prev.disabled = track.scrollLeft <= 1;
        if (next) next.disabled = track.scrollLeft >= maxScroll;
      };

      const scrollByStep = direction => {
        track.scrollBy({
          left: direction * track.clientWidth * 0.8,
          behavior: 'smooth'
        });
      };

      if (prev) prev.addEventListener('click', () => scrollByStep(-1));
      if (next) next.addEventListener('click', () => scrollByStep(1));

      track.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      updateButtons();
    };

    const initAll = scope => {
      scope.querySelectorAll('[data-collection-link-mosaic]').forEach(init);
    };

    initAll(document);
    document.addEventListener('shopify:section:load', event => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
